import { render, staticRenderFns } from "./PaymentIdListTop.vue?vue&type=template&id=b1b31e1a&scoped=true&"
import script from "./PaymentIdListTop.vue?vue&type=script&lang=js&"
export * from "./PaymentIdListTop.vue?vue&type=script&lang=js&"
import style0 from "./PaymentIdListTop.vue?vue&type=style&index=0&id=b1b31e1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b31e1a",
  null
  
)

export default component.exports